import { useState, useRef } from 'react'
import { Tabs, Swiper } from 'antd-mobile'
import styles from './index.scss'

function DpIndexSwiper(props: any) {
  const [activeKey, setActiveKey] = useState(props?.defaultActiveKey)
  const indexBarRef = useRef<any>(null)
  return (
    <div className={styles['dp-tabsIndex']} style={props?.style}>
      <div className={styles['dp-tabsIndex--nav']} style={props?.navStyle}>
        <Tabs
          activeLineMode={'fixed'}
          activeKey={activeKey}
          onChange={(key) => {
            const findIndex = props?.groups?.findIndex(item => item?.key === key)
            indexBarRef.current?.swipeTo(findIndex)
          }}
          style={{ '--fixed-active-line-width': '20px'}}
        >
          {(props?.groups || []).map((item: any) => <Tabs.Tab title={item.title} key={item.key} />)}
        </Tabs>
      </div>
      <div className={styles['dp-tabsIndex--container']} style={props?.containerStyle}>
        <Swiper {...props?.swiperPorps} onIndexChange={(e) => setActiveKey(props?.groups?.[e]?.key)} ref={indexBarRef}>
          {(props?.groups || [])?.map?.((item, index: number) => (
            <Swiper.Item key={index}>
              {props?.returnItems?.(item) ||
                <div className={styles['dp-tabsIndex--body']} key={item.key}>
                  {item?.body}
                </div>
              }
            </Swiper.Item>
          ))}
        </Swiper>
      </div>
  </div>
  )
}
export default DpIndexSwiper
